<!--
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2022-11-10 09:50:36
 * @LastEditors: w9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2023-10-24 17:18:35
 * @FilePath: \sns-user-frontend\src\components\tagGroup.vue
 * @Description: 标签组组件
-->
<template lang="">
  <div @click.stop class="tag-group">
    <el-check-tag
      v-for="(item, index) in tagList"
      :key="item.value"
      :checked="item.checked"
      @change="(e) => {onSelectTag(e, index)}"
      :style="{
        borderRadius: round ? '100px' : '0',
        border: border ? '1px solid var(--outline)' : 'none'
      }"
      @click.stop
    >
      {{ props.translate ? $t(item.name) : item.name }}
    </el-check-tag>
  </div>
</template>
<script setup>

import { ref, watch } from 'vue'
const emit = defineEmits(['updateSelected'])
const props = defineProps({
  tagList: {
    type: Array,
    default: () => {
      return []
    }
  },
  selected: {
    type: [String, Number],
    default: ''
  },
  translate: {
    type: Boolean,
    default: true
  },
  round: {
    type: Boolean,
    default: false
  },
  border: {
    type: Boolean,
    default: true
  }
})

const tagList = ref(props.tagList)
const selected = ref(props.selected)

const onSelectTag = (e, selectedIndex) => {
  tagList.value.forEach((t, index) => {
    t.checked = selectedIndex === index
  })
  emit('updateSelected', tagList.value[selectedIndex].value, )
}

watch(() => props.selected, (val) => {
  tagList.value.find(t => t.value === val).checked = true
  tagList.value.forEach(t => {
    t.checked = t.value === val
  })
  selected.value = val
}, { immediate: true, deep: true })

</script>
<style lang="postcss" scoped>
  .el-check-tag {
    --el-border-radius-base: var(--button-radius);
    --el-color-info: var(--text-primary);
    background-color: var(--color-background-primary);
    font-size: 16px;
    line-height: 16px;
    padding: 8px 16px;
    border: 1px solid var(--outline);
    margin-right: 16px;
    -webkit-user-select:none;
    -moz-user-select:none;
    -o-user-select:none;
    user-select:none;
  }
  .is-checked {
    border: 1px solid var(--background-primary) !important;
    color: var(--text-primary-reverse) !important;
    background: var(--background-primary) !important;
    &:hover {
      background: var(--background-primary);
    }
  }
  @media screen and (max-width: 1023px) {
    .el-check-tag {
      box-sizing: border-box;
      display: inline-flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      height: 32px;
      padding: 8px 23px;
    }
  }
</style>